import React from 'react'
import Markdown, { Components } from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

export const MarkdownRenderer: React.FC<{ markdown: string; components?: Partial<Components> }> = ({ markdown, components }) => {
  return (
    <div className="prose prose-sm max-w-none">
      <Markdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeRaw]}
        components={{
          ...components,
        }}
      >
        {markdown}
      </Markdown>
    </div>
  )
}
